var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 4.5C18.8437 4.55019 19.1777 4.61301 19.5 4.68745C20.0912 4.824 20.3868 4.89228 20.741 5.1749C20.943 5.33609 21.1952 5.65516 21.3059 5.88973C21.5 6.30099 21.5 6.6998 21.5 7.49742V18.3599C21.5 19.353 20.46 20.0351 19.5 19.8134C18.5803 19.6009 17.5659 19.4832 16.5 19.4832C14.5829 19.4832 12.8325 19.864 11.5 20.4916C10.1675 21.1192 8.41707 21.5 6.5 21.5C5.43408 21.5 4.41969 21.3823 3.5 21.1699C2.9088 21.0333 2.61319 20.965 2.25898 20.6824C2.05696 20.5212 1.80483 20.2021 1.69412 19.9676C1.5 19.5563 1.5 19.1575 1.5 18.3599V7.49742C1.5 6.50432 2.54003 5.82223 3.5 6.04395C3.82232 6.1184 4.15627 6.18121 4.5 6.2314",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1575",
    d: "M14 13C14 14.3807 12.8807 15.5 11.5 15.5C10.1193 15.5 9 14.3807 9 13C9 11.6193 10.1193 10.5 11.5 10.5C12.8807 10.5 14 11.6193 14 13Z",
    stroke: "#5784F7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5 14L5 14.009",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18 11.9922L18 12.0012",
    stroke: "#5784F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5 1.5V5.5M7.5 4.5L7.5 6.5M15.5 2.5V4.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon6);
export default __webpack_public_path__ + "static/media/LineIcon6.00b80e829e36b87f62bb51fa07eb1f0a.svg";
export { ForwardRef as ReactComponent };